import Cookies from 'js-cookie';
import { GROUPS, IBIS } from '../app/constants';

export const getTourGroup = () => {
  const group = Cookies.get('tourGroup');
  if (group && GROUPS.includes(group)) {
    return group;
  }
  return IBIS;
};
